import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    IconButton,
    Grid,
    FormGroup,
    Stack,
    FormControlLabel,
    Tooltip,
    Checkbox
} from "@mui/material";
import { Close } from "@mui/icons-material";
import ListIcon from '@mui/icons-material/List'
import { selectPolicyDetails, updateSelectedPolicyDetails } from "src/features/rfqDataSlice";
import { useDispatch, useSelector } from "react-redux";
import HeaderSelection from "./HeaderManagement/HeaderSelection";
import HeaderSettings from "./HeaderManagement/HeaderSettings";
import HeaderSorting from "./HeaderManagement/HeaderSorting";
import SnackbarAlert from "src/pages/common/SnackbarAlert";

export default function AddNewHeaderBox({ onClose, sumInsuredData }) {
    const dispatch = useDispatch();
    const policyDetails = useSelector(selectPolicyDetails);
    const [screenNumber, setScreenNumber] = useState(1);
    const [sortedHeads, setSortedHeads] = useState([]);
    const [showSnackBarAlert, setShowSnackBarAlert] = useState({
        status: false,
        type: 'success',
        message: null
    });
    const handleSnackbarClose = () => {
        setShowSnackBarAlert({ status: false, type: null, message: null });
    };

    // identify permanent headers (already in sumInsuredHeaderSorted but not in missingHeaders)
    const permanentHeaders =
        sumInsuredData?.sumInsuredHeaderSorted?.filter(
            (h) =>
                !sumInsuredData?.missingHeaders?.some(
                    (m) => m?.sumInsuredHeader?.attribute === h?.sumInsuredHeader?.attribute
                )
        ) || [];

    // identify additional headers (the ones from missingHeaders that user can toggle)
    const initialSelected =
        sumInsuredData?.sumInsuredHeaderSorted?.filter((h) =>
            sumInsuredData?.missingHeaders?.some(
                (m) => m?.sumInsuredHeader?.attribute === h?.sumInsuredHeader?.attribute
            )
        ) || [];

    const [selectedHeads, setSelectedHeads] = useState(initialSelected);

    const containsObject = (obj, list) =>
        list?.some(
            (item) =>
                item?.sumInsuredHeader?.attribute === obj?.sumInsuredHeader?.attribute
        );

    const checkIsSelected = (head) => containsObject(head, selectedHeads);

    const selecthead = (head) => {
        let selectedHeadArr = [...selectedHeads];
        const attr = head?.sumInsuredHeader?.attribute;
        const isSelected = containsObject(head, selectedHeads);

        if (isSelected) {
            // remove
            selectedHeadArr = selectedHeadArr.filter(
                (item) => item?.sumInsuredHeader?.attribute !== attr
            );

            if (attr === "vehicleMake") {
                selectedHeadArr = selectedHeadArr.filter(
                    (item) =>
                        item?.sumInsuredHeader?.attribute !== "vehicleModel" &&
                        item?.sumInsuredHeader?.attribute !== "vehicleVariant"
                );
            }
        } else {
            // add
            selectedHeadArr.push(head);

            if (attr === "vehicleMake") {
                const variant = sumInsuredData?.missingHeaders.find(
                    (item) => item?.sumInsuredHeader?.attribute === "vehicleVariant"
                );
                const model = sumInsuredData?.missingHeaders.find(
                    (item) => item?.sumInsuredHeader?.attribute === "vehicleModel"
                );

                if (variant && !containsObject(variant, selectedHeadArr)) {
                    selectedHeadArr.push(variant);
                }
                if (model && !containsObject(model, selectedHeadArr)) {
                    selectedHeadArr.push(model);
                }
            }
        }

        setSelectedHeads(selectedHeadArr);
    };

    const saveHeaders = () => {
        const updatedPolicy = {
            ...policyDetails,
            policySumInsuredSections: policyDetails.policySumInsuredSections.map(
                (section) =>
                    section.id === sumInsuredData.id
                        ? {
                            ...section,
                            sumInsuredHeaderSorted: sortedHeads
                        }
                        : section
            )
        };
        const cleanPolicy = JSON.parse(JSON.stringify(updatedPolicy));
        dispatch(updateSelectedPolicyDetails(cleanPolicy));
        onClose();

    };

    const nextScreen = () => {
        if (screenNumber == 1) {
            setSortedHeads([...selectedHeads, ...permanentHeaders,])
        }
        if (selectedHeads.length < 1) {
            setShowSnackBarAlert({
                status: true,
                type: 'error',
                message: 'Select Header'
            });
            return;
        }
        setScreenNumber((prev) => { if (prev >= 1 && prev < 3) { return prev + 1; } })

    }
    const prevScreen = () => {
        setScreenNumber((prev) => { if (prev <= 3 && prev >= 2) { return prev - 1; } })
    }


    return (
        <Dialog open={true} onClose={onClose} fullWidth maxWidth="md">
            <SnackbarAlert
                showSnackBarAlert={showSnackBarAlert}
                handleSnackbarClose={handleSnackbarClose}
            />
            <DialogTitle
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                Add Header
                <IconButton onClick={onClose}>
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {screenNumber == 1 && <HeaderSelection sumInsuredData={sumInsuredData} checkIsSelected={checkIsSelected} selecthead={selecthead} />}
                {/* {screenNumber == 2 && <HeaderSettings sumInsuredData={sumInsuredData} selectedHeads={selectedHeads} setShowSnackBarAlert={setShowSnackBarAlert} setSelectedHeads={setSelectedHeads} />} */}
                {screenNumber == 2 && <HeaderSorting sumInsuredData={sumInsuredData} headerList={sortedHeads} setSortedHeads={setSortedHeads} />}

            </DialogContent>

            <DialogActions>
                {/* <Button onClick={onClose} color="secondary" variant="outlined">
                    Cancel
                </Button>
                <Button onClick={saveHeaders} color="primary" variant="contained">
                    Save
                </Button> */}
                {screenNumber <= 2 && screenNumber > 1 && <Button onClick={prevScreen} color="secondary" variant="outlined">
                    Back
                </Button>}
                {screenNumber == 2 && <Button onClick={saveHeaders} color="primary" variant="contained" disabled={sortedHeads.length < 1}>
                    Save
                </Button>}
                {screenNumber < 2 && <Button onClick={nextScreen} color="primary" variant="contained" disabled={selectedHeads.length<1}>
                    Next
                </Button>}




            </DialogActions>
        </Dialog>
    );
}

